let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iG1Cs")).then(() => parcelRequire('gU4j4'));